import styled from '@emotion/styled';
import * as Airline from './columns/Airline';
import * as Airport from './columns/Airport';
import * as DetailsLink from './columns/DetailsLink';
import * as Time from './columns/Time';
import * as FlightNumber from './columns/FlightNumber';
import * as Gate from './columns/Gate';
import * as Status from './columns/Status';
import * as BaggageBelt from './columns/BaggageBelt';
import { FlightListScope } from '../../domain/constants/FlightListScope';
import { ITheme, Responsive, RowRole } from '../../../../../ui';
import { Color } from '../../../../../styles/Color';

export const StyledRow = styled(RowRole)<{}, ITheme>`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	border-bottom: 1px solid ${Color.Neutral2};
	font-size: ${(props) => props.theme.typography?.small?.size};
	font-weight: 400;
	color: ${Color.Neutral6};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;

const ColumnGroup = styled.div`
	display: flex;
	flex: 1;
`;

interface IProps {
	scope: FlightListScope;
}

export function FlightListHeader({ scope }: IProps) {
	return (
		<StyledRow>
			<Time.Header />
			<ColumnGroup>
				<Airport.Header scope={scope} />
				<FlightNumber.Header />
			</ColumnGroup>
			<Gate.Header />
			{scope === FlightListScope.Arrivals && <BaggageBelt.Header />}
			<Airline.Header />
			<ColumnGroup>
				<Status.Header />
				<DetailsLink.Header />
			</ColumnGroup>
		</StyledRow>
	);
}
